import { SystemMessage } from '@/interfaces/systemMessage';
import { SystemMessageResource, systemMessageResource } from '@/resources/systemMessage.resource';
import { getProfileId } from '@/utils/profile';
import { EntityModule } from './entity.module';

/**
 * Moduł powiadomień systemowych
 *
 * @export
 * @class SystemMessageModule
 * @extends {EntityModule<SystemMessage, SystemMessageResource>}
 */
export class SystemMessageModule extends EntityModule<SystemMessage, SystemMessageResource> {
  constructor() {
    super(systemMessageResource);

    this.state = {
      ...this.state,
      unreadList: [],
      unreadCount: 0
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje listę nieprzeczytanych powiadomień
       *
       * @param {*} localState
       * @param {SystemMessage[]} list
       */
      saveUnreadList(localState: any, list: SystemMessage[]): void {
        localState.unreadList = list;
      },

      /**
       * Zapisuje ilość nieprzeczytanych powiadomień
       *
       * @param {*} localState
       * @param {*} count
       */
      saveUnreadCount(localState: any, count: any): void {
        localState.unreadCount = count;
      },

      /**
       * Oznaczenie jako przeczytaną
       *
       * @param {*} localState
       * @param {number} id
       */
      markAsRead(localState: any, id: number): void {
        localState.unreadList.splice(
          localState.unreadList.findIndex((item: SystemMessage) => item.id === id),
          1
        );
        localState.unreadCount = localState.unreadList.length;
      }
    };

    const originalListAction = this.actions.list;

    this.actions = {
      ...this.actions,

      /**
       * Oznacza wiadomość jako przeczytaną
       *
       * @param {*} context
       * @param {number} id
       * @returns {Promise<number>}
       */
      read: (context: any, id: number): Promise<void> => {
        return this.resource.read(id).then(() => {
          context.commit('markAsRead', id);
        });
      },

      /**
       * Pobiera listę nieprzeczytanych powiadomień
       *
       * @param {*} context
       * @returns {Promise<void>}
       */
      unreadList: (context: any, preventLoader: boolean): Promise<void> => {
        return this.resource
          .list({ read: false, visibilityDate: new Date(), receiverId: getProfileId() } as any, preventLoader)
          .then(({ list, count }) => {
            context.commit('saveUnreadList', list);
            context.commit('saveUnreadCount', count);
          });
      },

      /**
       * Pobiera listę powiadomień
       *
       * @param {*} context
       * @returns {Promise<void>}
       */
      list: (context: any, filters: any): Promise<void> => {
        return originalListAction(context, { ...filters, receiverId: getProfileId() });
      }
    };
  }
}

export default new SystemMessageModule();
